import { useEffect, useRef } from 'react';
import EcoSpace from 'eco-design/base/eco-space';
import EcoImg from 'eco-design/base/eco-img';
import css from './index.module.scss';
import { useLang } from '@/app/utils/useLang';
import { useWebpOrJpg } from '../../hooks/useWebpOrJpg';
import getLocal from '@/app/utils/i18n';

const Roof: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('dpux.Roof');
    const { t: t2 } = useLang('dpux');
    const webpOrJpg = useWebpOrJpg('#delta-pro-ultra-x-Roof');

    /** 动画 */
    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const label = sectionRef.current.querySelector('.label');
        const title = sectionRef.current.querySelector('.title');
        const desc = sectionRef.current.querySelector('.desc');
        const tips = sectionRef.current.querySelector('.footer-tips');
        const container = sectionRef.current.querySelector('.img-container');
        const screen = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                label?.classList.add('enter');
                title?.classList.add('enter');
                desc?.classList.add('enter');
                tips?.classList.add('enter');
                container?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    label?.classList.remove('enter');
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                    tips?.classList.remove('enter');
                    container?.classList.remove('enter');
                }
            },
        });
        return () => {
            screen.destroy?.();
        };
    }, []);
    return (
        <>
            <EcoSpace />
            <section
                className={`${css.section} delta-pro-ultra-x-Roof GtmModuleData-section`}
                id="delta-pro-ultra-x-Roof"
                data-section-id={'delta-pro-ultra-x-Roof'}
                data-section-title={t('title')}
                ref={sectionRef}
            >
                <div className="info">
                    <div className="left">
                        <div className="label ani-1">
                            {t.rich('label', {
                                sup: (v: string) => <sup>{v}</sup>,
                            })}
                        </div>
                        <div className="title ani-2">{t('title')}</div>
                    </div>
                    <div className="desc right ani-2">{t('desc')}</div>
                </div>
                <div className="img-container ani-3">
                    <EcoImg
                        pc={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1761545186048/roof.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1761545185577/roof.webp',
                        )}
                        h5={webpOrJpg(
                            'https://websiteoss.ecoflow.com/upload/image/1761545185794/roof-m.jpg',
                            'https://websiteoss.ecoflow.com/upload/image/1761545186238/roof-m.webp',
                        )}
                    />
                </div>
                {locale === 'ca' && <div className="footer-tips ani-3">{t2('item_Remarks3')}</div>}
                <EcoSpace />
            </section>
        </>
    );
};

export default Roof;
